import { iDataCenterDoc } from "@/app/models/interfaceProject";
import { FileQuestion, FileText, Pencil, Trash2, Download, CloudDownload, FileSymlink, MoreVertical } from "lucide-react";
import Tooltip from "../Elements/Tooltip";
import { useUser } from "@/app/context/UserContext";
import { LOCAL_ICON_COLOR, OriginFile, StatusFile, TypeFile, TypeLayout } from "@/app/constants/enums";
import Loading from "../Elements/Loading";
import { checkIfFiveMinutesPassed } from "@/app/helpers/functions";
import { DriveExcelIcon } from "../Elements/Icon/DriveExcelIcon";
import { DrivePdfIcon } from "../Elements/Icon/DrivePdfIcon";
import { DriveSym } from "../Elements/Icon/DriveSym";
import { useEffect, useRef, useState } from "react";
import { DriveFileIcon } from "../Elements/Icon/DriveFileIcon";


interface DatacenterListProps {
  files: iDataCenterDoc[];
  onDelete: (file: iDataCenterDoc) => void;
  onDownload: (file: iDataCenterDoc) => void;
  onEdit: (file: iDataCenterDoc) => void; 
  onUpdateDriveFile?: (file: iDataCenterDoc) => void; 
  onUpdateDrive?: (file: iDataCenterDoc) => void; 
  idView:string;
  isEditingForm:boolean;
}

export default function DatacenterList({ files, onDelete, onDownload, onEdit, onUpdateDriveFile, onUpdateDrive, idView, isEditingForm }: DatacenterListProps) { 
  const { typeLayout,userProject} = useUser();

  const formatDate = (dateStr:string) => {
    if (!dateStr) return "";
    const year = dateStr.slice(0, 4);
    const month = dateStr.slice(4, 6);
    const day = dateStr.slice(6, 8);
    // const hour = dateStr.slice(8, 10);
    // const min = dateStr.slice(10, 12);
    // const sec = dateStr.slice(12, 14);

    return `${day}/${month}/${year}`;
  };
  const menuRef = useRef<HTMLDivElement>(null);
  const [activeMenu, setActiveMenu] = useState<string | null>(null);
  const toggleMenu = (fileId: string) => {
      setActiveMenu((prev) => (prev === fileId ? null : fileId));
    };
  useEffect(() => {
      const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setActiveMenu(null); 
      }
      };

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      };
  }, []);

  return (
    <ul className="w-full mt-2">
      {typeLayout === TypeLayout.Personal?"":
      <li key={-1} className={`flex items-center py-1 w-full border-b ${idView=="qa"?"bg-blue-100":""} `}>
          <div className="flex items-center flex-1 min-w-0">
            <Tooltip 
              className=""
              text={ `${userProject.qa.length} Preguntas y Respuestas`  }>
              <span className="flex items-center overflow-hidden">
                <span>
                <FileQuestion strokeWidth={1} className={`text-blue-500 w-6 h-6`} /> 
                </span>
                <span className="truncate overflow-hidden text-ellipsis whitespace-nowrap w-full pl-2 text-sm font-medium"> 
                  Preguntas y Respuestas  
                </span> 
              </span> 
            </Tooltip>
          </div>
          <div className="flex items-center justify-end ml-2"> 
            
            <button type="button" 
              onClick={() => onDelete({type:TypeFile.Qa, file_id_local:""})} 
              className={`btn-inca-secondary shadow-md rounded-full w-9 h-9 border border-gray-300 ${isEditingForm?"":"hidden" }`}
              disabled={!isEditingForm}
            >
                <Trash2  className="w-4 h-4 m-2" strokeWidth={1.5} />
            </button> 

            
          </div>
        </li>
      }
      {files.map((file, index) => (
        <li key={index}  className={`flex items-center justify-between py-1 w-full border-b ${idView==file.file_id?"bg-blue-100":""} `}>
          <div className="flex items-center flex-1 min-w-0">
            <Tooltip 
              className="w-full"
              text={
                file.created_date
                  ? `${file.name ?? ""}\n Subido el: ${formatDate(file.created_date)}`
                  : file.name ?? ""
              }>
              <span className="flex items-center overflow-hidden">
                <span>     
                  {file?.file_origin==OriginFile.Drive? 
                    <DriveFileIcon size={22} className={LOCAL_ICON_COLOR[(file?.type??"") as TypeFile]??"text-gray-500"}/>
                    :
                    <FileText size={22} className={LOCAL_ICON_COLOR[(file?.type??"") as TypeFile]??"text-gray-500"}/>
                  } 
                                              
                </span>
                <span className="truncate overflow-hidden text-ellipsis whitespace-nowrap w-full pl-2 text-sm font-medium"> 
                {file.name}
                </span> 
              </span> 
            </Tooltip>
          </div>
          
          <div className="flex items-center justify-end ml-2">
            {file.file_id?(
            file.status == StatusFile.Error ?(
              <button type="button" 
                onClick={() => onDelete(file)} 
                className={`flex items-center w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 text-blue-700 ${isEditingForm?"":"hidden" }`}
                disabled={!isEditingForm}
              >
                <Trash2 size={20}  strokeWidth={1.5} className="text-blue-600" />
              </button> 
            ):
            file.status == StatusFile.Created ? 
              <Loading w="w-1" h="h-1" className=""/>: 
              <button type="button" 
                onClick={() => toggleMenu(file.file_id_local)}
                className={`rounded-full text-blue-700 hover:bg-slate-200 transition duration-150 ease-in-out p-1`}
              >
                  <MoreVertical strokeWidth={1.5} />
              </button> 
            ):
            <button type="button" 
              onClick={() => onDelete(file)} 
              className={`btn-inca-secondary shadow-md rounded-full w-9 h-9 border border-gray-300 ${isEditingForm?"":"hidden" }`}
              disabled={!isEditingForm}
            >
                <Trash2  className="w-4 h-4 m-2" strokeWidth={1.5} />
            </button> 
            }

             { file.file_id_local===activeMenu&&(
                <div 
                    key={file.file_id_local+"menu"}                     
                    ref={menuRef} 
                    className={`
                    absolute mt-36 w-52 py-2 bg-white border border-gray-300 rounded-lg shadow-lg z-20
                    transition-all duration-300 ease-in-out 
                    ${activeMenu !== file.file_id_local ? "animate-fadeOut" : "animate-fadeIn"}
                    `}
              
                > 
                 <button type="button" 
                    onClick={() => onDownload && onDownload(file)}
                    className={`flex items-center w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 text-blue-700 `}
                  >
                      <Download size={20} strokeWidth={1.5} className="text-blue-600" /> <span className="ml-2 ">Descargar</span>
                  </button> 
                  <button type="button" 
                    onClick={() => onDelete(file)} 
                    className={`flex items-center w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 text-blue-700 ${isEditingForm?"":"hidden" }`}
                    disabled={!isEditingForm}
                  >
                    <Trash2 size={20}  strokeWidth={1.5} className="text-blue-600" /> <span className="ml-2 ">Eliminar</span>
                  </button> 

                {file?.drive_id&&(
                    <button type="button" 
                    onClick={(e) => {
                      e.stopPropagation(); 
                      onUpdateDrive?.(file);
                      toggleMenu(file.file_id_local);
                      //onUpdateDriveFile?.(file);
                    }}
                    className="flex items-center w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                  >
                      <DriveSym size={20} /> <span className="ml-2 ">Actualizar desde Drive</span>
                  </button> 

                )} 
                  
              
              </div>
            
             )
             }
            


            

            {/* 
          {file.status === StatusFile.Created? 
            <>
              <Loading w="w-1" h="h-1" className=""/> 
              {checkIfFiveMinutesPassed(file.created_date??"")&&(
                <button type="button" 
                  onClick={() => onDelete(file)} 
                  className={`btn-inca-secondary shadow-md rounded-full w-9 h-9 border border-gray-300 ${isEditingForm?"":"hidden" }`}
                  disabled={!isEditingForm}
                >
                    <Trash2  className="w-4 h-4 m-2" strokeWidth={1.5} /> 
                </button> 
                
              )}
            </>
          :
            <>
          
              {file.file_id && file.type!=TypeFile.Pdf?
                
                <button 
                    type="button" 
                    aria-label="Edit" 
                    onClick={() => onEdit(file)} 
                    className="btn-inca-secondary shadow-md rounded-full w-9 h-9 border border-gray-300" 
                >
                    <Pencil className="w-4 h-4 m-2" strokeWidth={1.5} />
                </button>
                :
                ""
              } 
                
            <button type="button" 
              onClick={() => onDownload && onDownload(file)}
              className={`btn-inca-secondary shadow-md rounded-full w-9 h-9 border border-gray-300 `}
            >
                <Download  className="w-4 h-4 m-2" strokeWidth={1.5} />
            </button> 
            <button type="button" 
              onClick={() => onDelete(file)} 
              className={`btn-inca-secondary shadow-md rounded-full w-9 h-9 border border-gray-300 ${isEditingForm?"":"hidden" }`}
              disabled={!isEditingForm}
            >
              <Trash2  className="w-4 h-4 m-2" strokeWidth={1.5} />
            </button> 
             
            </>
          }
            */}
            </div>

        </li>
      ))}
    </ul>

    
  );
}